import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import api from "../../services/api";
import Template from "../../template";

import { useAuth } from "../../context/auth";

import CarregarPDFAluno from "../../components/CarregarPDFAluno";
import ChatDanizinha from "../../components/ChatDanizinha";
import { toast } from "react-toastify";

import * as S from "./styled";
import ComentariosAdicionais from "../../components/ComentariosAdicionais";

function CheckRedacoes(props) {
  const { id } = props.match.params;

  const { user, isLoadingUser } = useAuth();

  const [dadosRedacao, setDadosRedacao] = useState([]);
  const [initialHeight, setInitialHiehgt] = useState();
  const [highlights, setHighlights] = useState([]);
  const [showChat, setShowChat] = useState(true);
  const [chatInitialized, setChatInitialized] = useState(false);



  async function getFirstCorrection(){
    try {
      const retorno = await api.get(`/pegar-primeira-correcao/${id}`);

      const valores = retorno.data.map((item, idx) => {
        const conteudo = JSON.parse(item.conteudo);
        return conteudo.position.boundingRect.height;
      });

      setInitialHiehgt(valores[0]);
      getCorrecaoNova(valores[0]);
    } catch (err) {
    } finally {
      
    }
  }

  async function getCorrecaoNova(heightInicial = false) {
    try {
      const retorno = await api.get(`/pegar-correcao/${id}`);

      const valores = retorno.data.map((item, idx) => {
        const conteudo = JSON.parse(item.conteudo);
        conteudo.id = item.id;
        if(heightInicial){
          conteudo.position.boundingRect.height = heightInicial + 25;
        }

        if(initialHeight){
          conteudo.position.boundingRect.height = initialHeight + 25;
        }
        return conteudo;
      });

    
      setHighlights(valores);
    } catch (err) {
    } finally {
      return false;
    }
  }



  useEffect(() => {
    
    async function getPDF() {
      try {
        const data = {
          id: id,
        };

        const retorno = await api.post("/getCorrecao", data);
        console.log(user.nivel);
       
        // Só faz a verificação de permissão se o usuário estiver carregado
        if(!isLoadingUser){
          if(retorno.data.dadosRedacao[0].user_id !== user.id && user.nivel != 'a'){
            toast.error('Você não tem permissão para acessar essa página');
            setDadosRedacao([]);
          }else{
            setDadosRedacao(retorno.data.dadosRedacao);
          }
        }

        
      } catch (error) {}
    }

    // Só executa se o usuário já foi carregado
    if(!isLoadingUser){
      getPDF();
      getFirstCorrection();
    }
 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingUser]);

  return (
    <Template>
      <S.MainWrapper>
        <Container>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                {/* Exibir loading enquanto carrega os dados do usuário */}
                {isLoadingUser && (
                  <Row>
                    <Col>
                      <div className="text-center mt-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Carregando...</span>
                        </div>
                        <p className="mt-3">Carregando dados da redação...</p>
                      </div>
                    </Col>
                  </Row>
                )}
                
                {/* Conteúdo principal - só exibe quando não está carregando */}
                {!isLoadingUser && (
                  <>
                    <Row>
                      <Col>
                        <>
                          {dadosRedacao.length >= 1 && (
                        <CarregarPDFAluno
                          pdf={`${dadosRedacao[0].pdf}`}
                          id={id}
                          dadosRedacao={dadosRedacao}
                          highlights={highlights}
                        />
                      )}
                    </>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {dadosRedacao[0] && (
                      <>
                        {/* Faltas */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '12px' }}>
                          {[
                            { val: "1", label: "Texto Insuficiente" },
                            { val: "2", label: "Cópia" },
                            { val: "3", label: "Fuga ao Tema" },
                            { val: "4", label: "Fuga ao Gênero" },
                            { val: "5", label: "Fere Direitos Humanos" },
                            { val: "6", label: "Em Branco" },
                            { val: "7", label: "Outras Formas de Anulação" },
                          ].map(({ val, label }) => (
                            <span
                              key={val}
                              style={{
                                padding: '4px 10px',
                                borderRadius: '20px',
                                fontSize: '13px',
                                border: '1px solid #ccc',
                                background: dadosRedacao[0].falta === val ? '#024995' : '#f8f9fa',
                                color: dadosRedacao[0].falta === val ? '#fff' : '#333',
                                fontWeight: dadosRedacao[0].falta === val ? '600' : '400',
                              }}
                            >
                              {label}
                            </span>
                          ))}
                        </div>

                        {/* Reservado ao corretor */}
                        <div style={{ border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden', marginBottom: '8px' }}>
                          <div style={{ background: '#024995', color: '#fff', padding: '10px 14px', fontWeight: '700', fontSize: '15px' }}>
                            NOTAS
                          </div>
                          {[
                            { label: "1 - Demonstrar domínio da norma culta da língua escrita.", valor: dadosRedacao[0].competencia1 },
                            { label: "2 - Compreender a proposta de redação e aplicar conceitos de várias áreas de conhecimento para desenvolver o tema, dentro dos limites estruturais do texto dissertativo-argumentativo.", valor: dadosRedacao[0].competencia2 },
                            { label: "3 - Selecionar, relacionar, organizar, e interpretar informações, fatos, opiniões e argumentos em defesa do ponto de vista.", valor: dadosRedacao[0].competencia3 },
                            { label: "4 - Demonstrar conhecimento dos mecanismos linguísticos necessários para a construção da argumentação", valor: dadosRedacao[0].competencia4 },
                            { label: "5 - Elaborar proposta de solução para o problema abordado, mostrando respeito aos valores humanos e considerando a diversidade sociocultural.", valor: dadosRedacao[0].competencia5 },
                          ].map(({ label, valor }, i) => {
                            const nivelMap = { "0": "Nota", "40": "Nota", "80": "Nota", "120": "Nota", "160": "Nota", "200": "Nota" };
                            const nivel = nivelMap[String(parseInt(valor))] || "—";
                            return (
                              <div
                                key={i}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '10px 14px',
                                  borderTop: '1px solid #dee2e6',
                                  background: i % 2 === 0 ? '#fff' : '#f8f9fa',
                                  gap: '10px',
                                }}
                              >
                                <span style={{ fontSize: '13px', flex: 1 }}>{label}</span>
                                <span style={{
                                  minWidth: '64px',
                                  textAlign: 'center',
                                  background: '#024995',
                                  color: '#fff',
                                  borderRadius: '6px',
                                  padding: '4px 8px',
                                  fontWeight: '700',
                                  fontSize: '13px',
                                  whiteSpace: 'nowrap',
                                }}>
                                  {nivel} ({parseInt(valor)})
                                </span>
                              </div>
                            );
                          })}
                        </div>

                        <hr />

                        <table className="table table-striped table-bordered">
                          <tr>
                            <td className="text-right">
                              <h3>
                                <strong>Total: </strong>{" "}
                                {dadosRedacao[0] && dadosRedacao[0].falta ? (
                                  <>0</>
                                ) : (
                                  <>
                                    {parseInt(dadosRedacao[0].competencia1) +
                                      parseInt(dadosRedacao[0].competencia2) +
                                      parseInt(dadosRedacao[0].competencia3) +
                                      parseInt(dadosRedacao[0].competencia4) +
                                      parseInt(dadosRedacao[0].competencia5)}
                                  </>
                                )}
                              </h3>
                            </td>
                          </tr>
                        </table>

                        <hr />

                        <table className="table table-striped table-bordered">
                          <tr>
                            <td>{dadosRedacao[0].observacao}</td>
                          </tr>
                        </table>

                        <ComentariosAdicionais
                          comentarios={dadosRedacao[0].comentarios_adicionais}
                        />

                        <h4 className="text-center">
                          Rua Gavião Peixoto 124- Sala 509 -Edifício
                          Manhattan - 2601-0195/ (21) 96957-0209
                          <br />
                          cursodaniellevelasco@gmail.com{" "}
                        </h4>
                      </>
                    )}
                  </Col>
                </Row>
                </>
              )}
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>
      
      {/* Chat da Danizinha - Apenas para usuários do plano PRESENCIAL */}
      {dadosRedacao.length > 0 && user.plano === "PRESENCIAL" && (
        <>
          {/* {console.log('=== DADOS PASSADOS PARA CHATDANIZINHA ===')} 
           {console.log('showChat:', showChat)}
           {console.log('redacaoId (id da redação):', id)}
           {console.log('user.turma (ID da turma do usuário):', user.turma)}
           {console.log('dadosRedacao completo:', dadosRedacao)}
           {console.log('chatInitialized:', chatInitialized)}
           {console.log('============================================')} */}
          <ChatDanizinha
               show={showChat}
               onHide={() => setShowChat(false)}
               redacaoId={id}
               onInitialize={() => setChatInitialized(true)}
             />
        </>
      )}
    </Template>
  );
}

export default CheckRedacoes;
